module.exports = __webpack_public_path__ + "static/media/location.85adc4ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 655
// module chunks = 36